import type { NaverSyncLog } from '../types/naverSyncLog';

/** 반영 로그 결과 — 화면 필터 · 색 기준(감사 card-controltower#538 · #532, 백엔드 PR #76). */
export type SyncLogResult = 'SUCCESS' | 'SKIPPED' | 'FAILED';

/** 백엔드가 건너뜀 기록 메모 머리에 쓰는 글자(SKIPPED_PENDING — success=0 · put_attempted=0). */
const SKIPPED_PREFIX = /^건너뜀\s*—/;

/**
 * 기록 한 줄의 결과. outcome 이 있으면 그대로(DRY_RUN 은 success 칸대로), 옛 서버는 errorMessage 머리 '건너뜀 — ' 로
 * 건너뜀을 알아본다 — 건너뜀은 success=false 로 남지만 실패가 아니다(확정 대기 · 요청 대기라 보내지 않음).
 */
export function syncLogResult(l: Pick<NaverSyncLog, 'success' | 'errorMessage' | 'outcome'>): SyncLogResult {
  if (l.outcome === 'SKIPPED_PENDING') return 'SKIPPED';
  if (l.outcome === 'SUCCESS') return 'SUCCESS';
  if (l.outcome === 'FAILED') return 'FAILED';
  if (l.success) return 'SUCCESS';
  if (l.errorMessage && SKIPPED_PREFIX.test(l.errorMessage)) return 'SKIPPED';
  return 'FAILED';
}

export const SYNC_LOG_RESULT_LABEL: Record<SyncLogResult, string> = {
  SUCCESS: '성공',
  SKIPPED: '건너뜀',
  FAILED:  '실패',
};

/**
 * 화면 결과 필터 값 — 결과 셋에 '해소(RESOLVED)' 를 더한 것(백엔드 PR #95). 해소 = 실패 줄인데 그 뒤 같은 날 다시 해서 성공(resolvedAt).
 * '실패' 보기 · 다시 돌리기 대상은 남은 실패(outcome FAILED && !resolvedAt)만이다 — 해소된 줄을 다시 보내지 않게.
 */
export type SyncLogView = SyncLogResult | 'RESOLVED';

/** 실패였다가 그 뒤 다시 해서 성공한 줄인가(옛 서버는 resolvedAt 이 없어 늘 false — 예전처럼 실패로 남는다). */
export function isResolvedFailure(l: Pick<NaverSyncLog, 'success' | 'errorMessage' | 'outcome' | 'resolvedAt'>): boolean {
  return syncLogResult(l) === 'FAILED' && typeof l.resolvedAt === 'string' && l.resolvedAt !== '';
}

export function syncLogView(l: Pick<NaverSyncLog, 'success' | 'errorMessage' | 'outcome' | 'resolvedAt'>): SyncLogView {
  return isResolvedFailure(l) ? 'RESOLVED' : syncLogResult(l);
}

export const SYNC_LOG_VIEW_LABEL: Record<SyncLogView, string> = {
  ...SYNC_LOG_RESULT_LABEL,
  RESOLVED: '재시도 성공',
};

/**
 * 해소된 실패 줄의 배지 글 — 가격 받기 · 동기화(조회)는 '재수집 성공', 네이버로 쓰는 반영(③ · 자동 상승 등)은 '재반영 성공'.
 */
export function resolvedBadgeLabel(jobType: string): string {
  return jobType === 'UPDATE_PRICES' || jobType === 'SYNC_STOCK' ? '재수집 성공' : '재반영 성공';
}
